module.exports = __webpack_public_path__ + "img/workshops.19a2ca78.jpg";